export const SERVICE_PROVIDER_FACTORY_CONTRACT_ADDRESS = '0xD17A9bc90c582249e211a4f4b16721e7f65156c8';
//# sourceMappingURL=constants.js.map